import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
const usageTracker = createTracker({
  events
});
export default usageTracker;